import { render, staticRenderFns } from "./TokensPriceView.vue?vue&type=template&id=04ec029d"
import script from "./TokensPriceView.vue?vue&type=script&lang=ts"
export * from "./TokensPriceView.vue?vue&type=script&lang=ts"
import style0 from "./TokensPriceView.vue?vue&type=style&index=0&id=04ec029d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports